import PortableStorageHero from 'assets/images/psp/PSPHero/portable-hero.webp';

import convenienceIcon from 'assets/images/icons/psp/portable-storage/convenience.svg';
import loadingTimeIcon from 'assets/images/icons/psp/portable-storage/loading-time.svg';
import movingHelpIcon from 'assets/images/icons/psp/portable-storage/moving-help.svg';
import securityIcon from 'assets/images/icons/psp/portable-storage/security.svg';
import costStructureIcon from 'assets/images/icons/psp/portable-storage/cost-structure.svg';
import weatherProtectionIcon from 'assets/images/icons/psp/portable-storage/weather-protection.svg';
import businessUseIcon from 'assets/images/icons/psp/portable-storage/business-use.svg';

import HomeDiyIcon from 'assets/images/icons/psp/portable-storage/home-diy.svg';
import MovingPrepIcon from 'assets/images/icons/psp/portable-storage/moving-prep.svg';
import DeclutteringIcon from 'assets/images/icons/psp/portable-storage/decluttering.svg';
import SmallBusinessIcon from 'assets/images/icons/psp/portable-storage/small-business.svg';
import CollegeStudentsIcon from 'assets/images/icons/psp/portable-storage/college-students.svg';
import EmergencyIcon from 'assets/images/icons/psp/portable-storage/emergency.svg';

import mediumContainer from 'assets/images/icons/psp/portable-storage/portable-medium-container.svg';

import busyFamiliesIcon from 'assets/images/icons/psp/portable-storage/portable-busy-families.svg';
import diyEnthusiastsIcon from 'assets/images/icons/psp/portable-storage/portable-diy-enthusiasts.svg';
import apartmentRentersIcon from 'assets/images/icons/psp/portable-storage/portable-apartment-renters.svg';
import businessOwnersIcon from 'assets/images/icons/psp/portable-storage/portable-business-owners.svg';
import seniorsDownsizingIcon from 'assets/images/icons/psp/portable-storage/portable-seniors-downsizing.svg';
import militaryFamiliesIcon from 'assets/images/icons/psp/portable-storage/portable-military-families.svg';

import electronicsIcon from 'assets/images/icons/psp/portable-storage/electronics.svg';
import holidayDecorationsIcon from 'assets/images/icons/psp/portable-storage/holiday-decorations.svg';
import appliancesIcon from 'assets/images/icons/psp/portable-storage/appliances.svg';
import documentsIcon from 'assets/images/icons/psp/portable-storage/documents.svg';
import toolsIcon from 'assets/images/icons/psp/portable-storage/tools.svg';
import sportsIcon from 'assets/images/icons/psp/portable-storage/sports.svg';
import businessSuppliesIcon from 'assets/images/icons/psp/portable-storage/business-supplies.svg';
import furnitureIcon from 'assets/images/icons/psp/portable-storage/furniture.svg';

import PortableRelated1 from 'assets/images/psp/FeaturedContentImages/portable-related-1.jpeg';
import PortableRelated2 from 'assets/images/psp/FeaturedContentImages/portable-related-2.png';
import PortableRelated3 from 'assets/images/psp/FeaturedContentImages/portable-related-3.jpg';

import { storageCategories } from 'pages/PSPPage/utils/getPSPLinks';

const heroDescription =
	"Picture this: You're knee-deep in organizing your garage or [renovating your home](https://www.selfstorage.com/blog/home-renovations-to-increase-property-value-2/) when you realize you need more space. The thought of loading everything into your car and driving to a storage facility feels overwhelming. Enter portable storage—the smart solution that lets you pack at your own pace while keeping everything secure and accessible.\n\n" +
	'**SelfStorage.com** helps you find the perfect portable storage solution, from mini mobile storage containers to weatherproof storage containers that work around your schedule. No more multiple facility trips, rigid schedules, or loading stress.';

const reviews = [
	{
		title: 'Julia was extremely thorough and...',
		stars: 5,
		text: 'Julia was extremely thorough and professional in helping me set up a storage container. She was fantastic!',
		link: 'https://www.trustpilot.com/reviews/67db24eb8431f628356e77cd',
		customerName: 'customer',
		date: 'March 19, 2025',
	},
	{
		title: 'The representative was very nice and...',
		stars: 5,
		text: 'The representative was very nice and helpful. He answered all my questions, and checked to make sure I was receiving the best deal available for the container size I wanted. It was an easy and fast experience.',
		link: 'https://www.trustpilot.com/reviews/665c956f82a4ececfd52e0ba',
		customerName: 'Nancy Gravatt',
		date: 'June 2, 2024',
	},
	{
		title: 'Ease of securing a storage container',
		stars: 5,
		text: 'Ease of securing a storage container on your website and having a "move in" date selected.',
		link: 'https://www.trustpilot.com/reviews/63b5b8f94d0773066a2ded99',
		customerName: 'Katharine Rinehart',
		date: 'January 3, 2023',
	},
	{
		title: 'Life saving tool',
		stars: 5,
		text: 'Trying to find a storage facility with availability in town can be a daunting and impossible feeling task. I was able to save myself so much time, money, gas, and headache by using selfstorage.com! Found my container and put in a reservation in under 10 minutes total! Life saver!!',
		link: 'https://www.trustpilot.com/reviews/5cf46330a84369094cfc5db1',
		customerName: 'Kimberly Nirenberg',
		date: 'June 3, 2019',
	},
];

const comparisonTableData = {
	title: 'Portable Storage vs. Traditional Storage Unit: Choosing the Right Option for Your Needs',
	subtitle: '',
	cardData: [
		{
			imageSrc: convenienceIcon,
			title: 'Convenience',
			content:
				'**Portable Storage:** Delivered to your location \n\n **Traditional Self Storage:** Drive to the facility',
			contentAlign: 'text-left',
		},
		{
			imageSrc: loadingTimeIcon,
			title: 'Loading time',
			content:
				'**Portable Storage:** Pack at your own pace \n\n **Traditional Self Storage:** Limited facility hours',
			contentAlign: 'text-left',
		},
		{
			imageSrc: movingHelpIcon,
			title: 'Moving help',
			content:
				'**Portable Storage:** Load once, unit moves with you \n\n **Traditional Self Storage:** Multiple trips required',
			contentAlign: 'text-left',
		},
		{
			imageSrc: securityIcon,
			title: 'Security',
			content:
				'**Portable Storage:** Container with lock included \n\n **Traditional Self Storage:** Varies by facility',
			contentAlign: 'text-left',
		},
		{
			imageSrc: costStructureIcon,
			title: 'Cost structure',
			content:
				'**Portable Storage:** All-inclusive pricing \n\n **Traditional Self Storage:** Monthly rent and potential admin fees',
			contentAlign: 'text-left',
		},
		{
			imageSrc: weatherProtectionIcon,
			title: 'Weather protection',
			content:
				'**Portable Storage:** Weatherproof containers \n\n **Traditional Self Storage:** Indoor & outdoor options vary',
			contentAlign: 'text-left',
		},
		{
			imageSrc: businessUseIcon,
			title: 'Business use',
			content:
				'**Portable Storage:** Provides flexibility for mobile business \n\n **Traditional Self Storage:** Fixed locations',
			contentAlign: 'text-left',
		},
	],
};

const whenYouNeedTableData = {
	title: 'When Would You Need Portable Storage?',
	cardData: [
		{
			imageSrc: HomeDiyIcon,
			title: 'Home renovation & DIY projects',
			content:
				'**Why Portable Storage Works** \n\n Keep belongings safe and accessible during projects',
			contentAlign: 'text-center',
		},
		{
			imageSrc: MovingPrepIcon,
			title: 'Moving preparation',
			content:
				'**Why Portable Storage Works** \n\n Pack gradually, then have it transported',
			contentAlign: 'text-center',
		},
		{
			imageSrc: DeclutteringIcon,
			title: 'Decluttering',
			content:
				'**Why Portable Storage Works** \n\n Sort items without multiple facility trips',
			contentAlign: 'text-center',
		},
		{
			imageSrc: SmallBusinessIcon,
			title: 'Small business inventory',
			content:
				'**Why Portable Storage Works** \n\n Flexible storage for a mobile storage business',
			contentAlign: 'text-center',
		},
		{
			imageSrc: CollegeStudentsIcon,
			title: 'College students',
			content:
				'**Why Portable Storage Works** \n\n Easy move-in/move-out solution',
			contentAlign: 'text-center',
		},
		{
			imageSrc: EmergencyIcon,
			title: 'Emergency',
			content:
				'**Why Portable Storage Works** \n\n Quick solution for unexpected life changes',
			contentAlign: 'text-center',
		},
	],
};

const sizeComparisonContent = {
	title: 'Mobile Storage Size Guide',
	noPadding: true,
	modules: [
		{
			type: 'sizeComparisonSection',
			props: {
				content: {
					title: 'Mobile Storage Size Guide',
					image: mediumContainer,
				},
				storageData: [
					{
						size: '8x7',
						heading: "8' Wide x 7' Long",
						desc: [
							'- Small portable storage fits up to 500 square feet, the size of a 5x10 self storage unit',
							'- This portable self storage container is best for studios or 1-bedroom apartments',
							'- Average price range is $149-$199/month',
						],
					},
					{
						size: '12x18',
						heading: "12' Wide x 18' Long",
						desc: [
							'- Medium portable storage ranges from 500 to 800 square feet, about the size of a 10x10 self storage unit',
							'- This portable self storage container is ideal for small home and medium apartment moves',
							'- Average price range is $199-$289/month',
						],
					},
					{
						size: '16x8',
						heading: "16' Wide x 8' Long",
						desc: [
							'- Large portable storage fits up to 1,200 square feet, offering same space as a 10x15 self storage unit',
							'- Popular choice for 3-4 bedroom home moves and renovations',
							'- Average price range is $289-$399/month',
						],
					},
				],
			},
		},
	],
};

const whoBenefitsData = {
	title: 'Who Benefits from Portable Storage?',
	subtitle: '',
	cardData: [
		{
			imageSrc: busyFamiliesIcon,
			title: 'Busy families',
			content: 'Load with flexible time, no facility scheduling',
			contentAlign: 'text-center',
		},
		{
			imageSrc: diyEnthusiastsIcon,
			title: 'DIY enthusiasts',
			content: 'Organize projects without storage facility trips',
			contentAlign: 'text-center',
		},
		{
			imageSrc: apartmentRentersIcon,
			title: 'Apartment renters',
			content: 'No long-term facility commitments required',
			contentAlign: 'text-center',
		},
		{
			imageSrc: businessOwnersIcon,
			title: 'Business owners',
			content:
				'Flexible inventory storage, mobile storage business potential',
			contentAlign: 'text-center',
		},
		{
			imageSrc: seniorsDownsizingIcon,
			title: 'Seniors downsizing',
			content: 'Pack gradually with family help',
			contentAlign: 'text-center',
		},
		{
			imageSrc: militaryFamiliesIcon,
			title: 'Military families',
			content: 'Storage units mobile enough for PCS moves',
			contentAlign: 'text-center',
		},
	],
};

const commonItemsData = {
	title: 'Common Items',
	cardData: [
		{
			title: 'Tools & Equipment',
			imageSrc: toolsIcon,
			content: '**Items:** Power tools, garden equipment',
			contentAlign: 'text-center',
		},
		{
			title: 'Sports & Outdoor Gear',
			imageSrc: sportsIcon,
			content: '**Items:** Bikes & dirt bikes, kayaks, camping equipment',
			contentAlign: 'text-center',
		},
		{
			title: 'Business Supplies',
			imageSrc: businessSuppliesIcon,
			content:
				'**Items:** Inventory, food truck supplies, promotional materials',
			contentAlign: 'text-center',
		},
		{
			title: 'Furniture',
			imageSrc: furnitureIcon,
			content: '**Items:** Sofas, dining sets, mattresses',
			contentAlign: 'text-center',
		},
		{
			title: 'Electronics',
			imageSrc: electronicsIcon,
			content: '**Items:** TVs, computers, gaming systems',
			contentAlign: 'text-center',
		},
		{
			title: 'Holiday Decorations',
			imageSrc: holidayDecorationsIcon,
			content:
				'**Items:** Christmas trees, Halloween decorations, party supplies',
			contentAlign: 'text-center',
		},
		{
			title: 'Appliances',
			imageSrc: appliancesIcon,
			content: '**Items:** Washer, dryer, oven, fridge',
			contentAlign: 'text-center',
		},
		{
			title: 'Documents',
			imageSrc: documentsIcon,
			content: '**Items:** Tax records, photos, certificates',
			contentAlign: 'text-center',
		},
	],
};

const faqs = [
	{
		question: 'How much do portable storage units cost?',
		answer:
			"Portable storage units prices vary by size and rental duration, but they're often more cost-effective than traditional storage when you factor in gas, time, and convenience.\n\n" +
			'Most companies offer transparent, all-inclusive pricing that covers delivery, pickup, and the container rental.',
	},
	{
		question: 'Are portable storage containers secure?',
		answer:
			'Yes! Every unit comes with reinforced door latches, heavy-duty hinges, and the ability to use your lock for maximum control.\n\n' +
			'Reputable companies use heavy-duty, weatherproof storage containers designed to protect your belongings from theft and weather damage.',
	},
	{
		question: "Can I access my items while they're stored?",
		answer: "Absolutely! Unlike traditional storage facilities with limited hours, you can access your portable container whenever it's convenient for you, whether at your location or the storage facility.",
	},
	{
		question:
			"What's the difference between portable storage units and mini mobile storage containers?",
		answer: 'Mini mobile storage containers are smaller versions perfect for apartment living or smaller projects, while full-size portable storage units can handle entire household moves. Both offer the same convenience and security features.',
	},
	{
		question: 'Can I use portable storage for my business?',
		answer:
			'Definitely! Many entrepreneurs use portable storage for mobile storage business operations, inventory management, or as flexible workspace storage.\n\n' +
			'The units are perfect for businesses that need storage flexibility.',
	},
	{
		question: 'How long can I keep a portable storage unit?',
		answer:
			'Rental periods are flexible—from a few days for quick projects to several months for major moves or renovations.\n\n' +
			'Many companies offer month-to-month options with no long-term commitments, while longer term contracts often come with discounts.',
	},
	{
		question: "What items shouldn't I put in portable storage?",
		answer: 'Avoid storing hazardous materials, perishables, or anything illegal. Most companies provide detailed list of prohibited items. When in doubt, check with the provider.',
	},
	{
		question: 'Do portable storage units protect against weather?',
		answer: 'Yes! Quality portable containers are weatherproof and designed to keep your belongings dry and protected in various weather conditions. Look for containers with proper sealing and ventilation.',
	},
];

export const PortableStorageContent = {
	type: 'Portable',
	reviews: reviews,
	sections: [
		{
			title: 'Portable Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					id: 'portable-storage-hero',
					props: {
						content: {
							title: 'Find Affordable Portable Self Storage',
							description: heroDescription,
							image: PortableStorageHero,
							hideCTA: 'true',
						},
					},
				},
			],
		},
		{
			title: 'portable vs traditional section',
			background: 'white',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: comparisonTableData.title,
						description: comparisonTableData.subtitle,
						content: '',
						cardData: comparisonTableData.cardData,
					},
				},
			],
		},
		{
			title: 'When Would You Need Section',
			background: 'white',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: whenYouNeedTableData.title,
						description: whenYouNeedTableData.subtitle,
						cardData: whenYouNeedTableData.cardData,
					},
				},
			],
		},
		sizeComparisonContent,
		{
			title: 'Who Benefits Section',
			background: 'white',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: whoBenefitsData.title,
						description: whoBenefitsData.subtitle,
						content: '',
						cardData: whoBenefitsData.cardData,
					},
				},
			],
		},
		{
			title: 'Common Items Section',
			background: 'white',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: commonItemsData.title,
						description: commonItemsData.subtitle,
						content: '',
						cardData: commonItemsData.cardData,
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							reviews,
							headerTitle: 'Portable Self Storage: ',
						},
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			background: 'white',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							header: 'Portable Self Storage FAQs',
							faqs,
						},
					},
				},
			],
		},
		{
			title: 'related content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading: 'Learn All About Portable Self Storage',
							type: 'portableStorageRelatedContent',
							id: 'portable-storage-related-content',
							data: {
								slug: 'portable-storage-related-content',
								unitCards: [
									{
										title: 'Moving',
										date: 'June 18, 2025',
										image: PortableRelated1,
										url: 'https://www.selfstorage.com/blog/portable-storage-containers-what-you-need-to-know/',
										content:
											'Portable Storage Containers: What You Need to Know Before Renting',
									},
									{
										title: 'Moving',
										date: 'June 26, 2025',
										layout: false,
										plain: false,
										image: PortableRelated2,
										url: 'https://www.selfstorage.com/blog/portable-moving-container-vs-truck-rental/',
										content:
											'Portable Storage Containers vs Moving Truck Rentals',
									},
									{
										title: 'Moving',
										layout: false,
										plain: false,
										date: 'September 10, 2025',
										image: PortableRelated3,
										url: 'https://www.selfstorage.com/blog/pre-move-checklist/',
										content:
											'How to Prepare for a Move: Ultimate Pre-Move Checklist',
									},
								],
							},
						},
					},
				},
			],
		},
		{
			title: 'Links to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						heading: {
							headingName: 'More Ways to Store',
						},
						linksList: storageCategories.portableStorage,
					},
				},
			],
		},
		{
			title: 'nearby cities',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'Portable',
					},
				},
			],
		},
	],
};
